import { Button } from '@univdiam/ui/components/button';
import React from 'react';
import { useRouteError } from 'react-router-dom';

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div className="flex flex-col items-center justify-center h-screen text-center bg-gray-50">
            <h1 className="text-4xl font-bold mb-4">Something went wrong</h1>
            <p className="text-gray-700 mb-6">
                {"An unexpected error occurred."}
            </p>
            <Button>
                <a href="/">
                    Go Home
                </a>

            </Button>
        </div>
    );
}
